<template>
  <div class="main_center">
    <div class="content">
      <div class="search-content">
          <div class="mainBtn">
            <el-button @click="formHandle()" size="small" type="primary" v-if="hasBtnPermission('witness_personregister_add')">新增</el-button>
          </div>
          <div class="searchBtn">
            <span class="label-form">关键字查询：</span>
            <el-input @keyup.enter.native="getDataList" clearable placeholder="姓名/手机号" style="width: 200px" v-model="dataForm.searchKey"></el-input>
            <el-button @click="getDataList" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
          </div>
      </div>
      <el-table
        :data="dataList"
        :header-cell-style="this.$globalGrayTableHeaderStyle"
        :height="tableMaxHeight"
        @selection-change="selectionChangeHandle"
        @sort-change="sortChange"
        border
        stripe
        class="table-content"
        v-loading="dataListLoading">
        <el-table-column
          :index="getRowsIndex"
          align="center"
          fixed
          header-align="center"
          label="序号"
          type="index"
          width="60">
        </el-table-column>
        <el-table-column
                align="center"
                label="状态"
                prop="status"
                width="100">
          <template slot-scope="scope">
            <span style="display: inline-block;position: relative">
              <el-switch
                :width="50"
                @change="(val)=>updateStatus(val,scope.row)"
                active-color="#1890FF"
                inactive-color="rgba(0, 0, 0, 0.25)"
                v-model="scope.row.status">
              </el-switch>
              <span :class="scope.row.status?'switch-active':'switch-inactive'" class="switch-text">{{scope.row.status?'开启':'禁用'}}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          label="姓名"
          prop="personName"
          width="150">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          label="手机号"
          prop="phone"
          width="120">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          label="所属部门"
          prop="deptName">
        </el-table-column>
        <el-table-column
          align="left"
          header-align="center"
          label="修改人"
          prop="updateUser"
          width="200">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          sortable
          label="修改时间"
          prop="updateTime"
          width="160">
        </el-table-column>
        <el-table-column
          align="left"
          header-align="center"
          label="创建人"
          prop="createUser"
          width="200">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          sortable
          label="创建时间"
          prop="createTime"
          width="160">
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          header-align="center"
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button @click="formHandle('1',scope.row.id)" size="small" type="text">查看</el-button>
            <el-button @click="formHandle('2',scope.row.id)" size="small" type="text" v-if="hasBtnPermission('witness_personregister_add')">修改</el-button>
            <el-button @click="deleteHandle(scope.row.id)" size="small" type="text" v-if="hasBtnPermission('witness_personregister_delete')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="totalPage"
        @current-change="currentChangeHandle"
        @size-change="sizeChangeHandle"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  // import AddOrUpdate from './demo_edit'
  import { mapState } from "vuex";
  export default {
    props: ['mainContentViewHeight'],
    data () {
      return {
        dataForm: {
          searchKey: '',
        },
        sortParams: {
          order:'',
          prop:''
        },
        tableMaxHeight: document.documentElement.clientHeight - 227,
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: []
      }
    },
    components: {
      // AddOrUpdate
    },
    activated () {
      this.getDataList()
    },
    computed:{
		...mapState({
        isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}

    }),
	},
    mounted() {
      const that = this;
      let resizeTag = true
      window.onresize = () => {
        if (resizeTag) { //防抖动
          that.ifmove();
          resizeTag = false
          setTimeout(() => {
            resizeTag = true
          }, 1000)
        }
      }
      that.ifmove();
    },
    methods: {
      ifmove() {
        let tableMaxHeight = document.documentElement.clientHeight - 227;
        this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
        this.$nextTick(() => {
          this.tableMaxHeight = tableMaxHeight
        })
        //this.getDataList()
      },
      refresh() {//刷新按钮
        this.pageIndex = 1;
        this.dataForm.searchKey='';
        this.getDataList()
      },

      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        this.$httpReq.post('/openEvalPersonRegister/list',{
          'page': this.pageIndex,
          'rows': this.pageSize,
          'searchKey':this.dataForm.searchKey,
          'orderBy':(this.sortParams.prop && this.sortParams.order)?(this.sortParams.prop + (this.sortParams.order == "ascending"?' asc':' desc')):"",
          'filter':this.dataForm
        }).then(({data}) => {
          if (data ) {
            this.dataList = data.rows
            this.totalPage = data.totalItemCount
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      updateStatus(val,data){
        this.$confirm(`确定要${val ? '开启' : '禁用'}人员?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          this.$httpReq.post(`/openEvalPersonRegister/updateStatus`,data).then(res => {
            if (res.data.code == '1') {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getData();
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
              data.status = !val
            }
          })
        },()=>{
          data.status = !val
        })
      },
      getRowsIndex(index) {
        return (this.pageIndex - 1) * this.pageSize + index + 1
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      sortChange(column, prop, order){
        this.sortParams.prop = prop || column.prop;
        this.sortParams.order = order || column.order;
        this.getDataList();
      },
      // 查看
      formHandle (type,id) {
        let route_name = "";
        if (type === '1') {
          route_name = "personRegister_view"
        } else {
          route_name = "personRegister_edit"
        }
        this.$router.push({
          name:route_name,
          query:{
            id : id,
          }
        })
      },
      // 删除
      deleteHandle (id) {
        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$httpReq.post('/openEvalPersonRegister/delete',{id:id}).then(({data}) => {
            if (data && data.code === '1') {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }).catch(() => {})
      }
    }
  }
</script>
<style lang="scss" scoped>

  //列表页面
  .main_center{
    .switch-text{
      font-size: 12px;
      position: absolute;
      color: rgba(255, 255, 255, 1);
      line-height: 26px;
    }
    .switch-active{
      left:7px;
    }
    .switch-inactive{
      right:7px;
    }

  }

</style>